import {
  HULL_INSURANCE_INPUT_TYPE,
  HULL_INSURANCE_STATUS_LABEL,
} from "@/config/const";

const menuItemOptions = [
  { name: "事故一覧", path: "hull-insurance-claim-report-list" },
  { name: "マスター管理", path: "hull-insurance-template-manager" },
  { name: "必要情報マスター一覧", path: "hull-insurance-required-info-list" },
  { name: "損種テンプレート一覧", path: "hull-insurance-claim-type-list" },
];

export default {
  methods: {
    getMenuItemOptions(currentPath) {
      const options = menuItemOptions.filter(item => item.path !== currentPath);
      if (!options) return [];
      return options;
    },
    getInputTypeLabel(number) {
      const type = HULL_INSURANCE_INPUT_TYPE.find(
        item => item.value === number
      );
      if (!type) return "unknown";
      return type.text;
    },
    getStatusLabelColor(statusNumber) {
      return HULL_INSURANCE_STATUS_LABEL[statusNumber];
    },
    async getEnterpriseKind() {
      // 1: 船主
      // 2: 保険会社
      const res = await this.$store.dispatch("hullInsurance/getEnterpriseKind");
      if (res != null) {
        return res;
      } else {
        this.$vs.notify({
          title: "権限の取得に失敗しました。画面を更新してください。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
        return null;
      }
    },
  },
};
